import {Permission, type PermissionData} from "@/types/permissions/Permission";

export class Role {
    public id: number | null;
    public name: string;
    public description: string;
    public role_type: number;
    public permissions: Permission[];

    constructor(roledata: RoleData | void) {
        if (roledata === undefined) {
            this.id = null;
            this.name = "";
            this.description = "";
            this.role_type = 1;
            this.permissions = [];
        } else {
            this.id = roledata.id;
            this.name = roledata.name;
            this.description = roledata.description;
            this.role_type = roledata.role_type;

            this.permissions = [];
            if (roledata.permissions !== undefined) {
                roledata.permissions.forEach(permission => this.permissions.push((new Permission(permission))));
            }
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.name = '';
        this.description = '';
        this.role_type = 1;
        this.permissions = [];
    }

    public serializeData(): RoleData {
        const data: RoleData = {
            id: this.id,
            name: this.name,
            description: this.description,
            role_type: this.role_type,
            permissions: [],
        };

        this.permissions.forEach(permission => {
            data.permissions?.push(permission.serializeData());
        });
        return data;
    }
}

export type RoleData = {
    id: number | null;
    name: string;
    description: string;
    role_type: number;
    permissions: PermissionData[] | undefined;
}
